import { render } from "./PatientForm.vue?vue&type=template&id=19665e2c&scoped=true"
import script from "./PatientForm.vue?vue&type=script&lang=js"
export * from "./PatientForm.vue?vue&type=script&lang=js"

import "./PatientForm.vue?vue&type=style&index=0&id=19665e2c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19665e2c"]])

export default __exports__